import {
  Form,
  Flex,
  Text,
  Input,
  Button,
  Heading,
  FormLabel,
  FieldValues,
  FormControl,
  FormErrorMessage
} from '@homebotapp/hb-react-component-catalog'
import { BotHeadSpin } from '../../../Components'
import { useSignUpProvider } from '../SignUpContext'
import { defineMessages, useIntl } from 'react-intl'
import { emailRegex } from '../../../constants/regexes'
import { GLOBAL_SIGNUP } from '../../../constants/tracking/trackingEventLocations/globalTrackingEventLocation'

import styles from './Email.module.scss'

export const MSG = defineMessages({
  emailLabelDescription: {
    id: 'NewBuyerSignUp.emailStep.helper',
    defaultMessage: 'To get things started, enter your email.'
  },
  emailLabel: {
    id: 'NewBuyerSignUp.emailStep.label',
    defaultMessage: 'Your email'
  },
  emailRequired: {
    id: 'HomePreview.signUpForm.step1EmailRequired',
    defaultMessage: 'Email address is required.'
  },
  emailInvalid: {
    id: 'HomePreview.signUpForm.step1ValidEmail',
    defaultMessage: 'Please enter a valid email address.'
  },
  emailMagicLink: {
    id: 'NewBuyerSignUp.emailStep.emailMagicLink',
    defaultMessage: 'Email me a magic link'
  },
  signInWithPassword: {
    id: 'NewBuyerSignUp.emailStep.signInWithPassword',
    defaultMessage: 'Sign in with password'
  },
  cancel: {
    id: 'NewBuyerSignUp.nameStep.cancelBtn',
    defaultMessage: 'Cancel'
  },
  hiGuest: {
    id: 'NewBuyerSignUp.emailStep.salutation',
    defaultMessage: 'Hi, Guest!'
  },
  incorrectEmailOrPassword: {
    id: 'NewBuyerSignUp.emailStep.incorrectEmailOrPassword',
    defaultMessage: 'Incorrect email or password. Please try again.'
  }
})

export const Email = () => {
  const intl = useIntl()
  const { loading, handleCheckClient, handleSetClientEmail, passwordError } = useSignUpProvider()

  const handleSubmitEmailStep = (data: FieldValues, event: React.BaseSyntheticEvent) => {
    // Cast event.nativeEvent to any to handle submitter property
    const nativeEvent = event.nativeEvent as any

    if (nativeEvent?.submitter?.name === 'email-magic-link-btn') {
      handleCheckClient(data.emailAddress)
    } else if (nativeEvent?.submitter?.name === 'sign-in-with-password-btn') {
      handleSetClientEmail(data.emailAddress)
    }
  }

  if (loading) {
    return <BotHeadSpin panelSpacing />
  }

  return (
    <div className={styles.emailStep}>
      <Heading color='neutral-900' textAlign='left'>
        {intl.formatMessage(MSG.hiGuest)}
      </Heading>
      <Text color='neutral-700' size='sm'>
        {intl.formatMessage(MSG.emailLabelDescription)}
      </Text>
      <Form className={styles.form} onSubmit={(data, event) => handleSubmitEmailStep(data, event)}>
        {({ formState: { errors } }) => (
          <Flex flexDirection='column' justifyContent='space-between' flex={1}>
            <FormControl mb={4} isInvalid={!!errors?.emailAddress || passwordError}>
              <FormLabel>{intl.formatMessage(MSG.emailLabel)}</FormLabel>
              <Input
                size='sm'
                name='emailAddress'
                data-qa={`signup-email-input`}
                tracking={{
                  guid: 'feTvxxFzueSj5x7EPP7qYF',
                  ui_context: GLOBAL_SIGNUP
                }}
                rules={{
                  required: {
                    value: true,
                    message: intl.formatMessage(MSG.emailRequired)
                  },
                  pattern: {
                    value: emailRegex,
                    message: intl.formatMessage(MSG.emailInvalid)
                  }
                }}
              />
              <FormErrorMessage>
                {passwordError
                  ? intl.formatMessage(MSG.incorrectEmailOrPassword)
                  : errors?.emailAddress?.message?.toString()}
              </FormErrorMessage>
            </FormControl>
            <Flex direction='column'>
              <Button
                type='submit'
                marginBottom={3}
                name='email-magic-link-btn'
                tracking={{
                  guid: 'cTjVjzAGSgapnuBDv73Hnx',
                  descriptor: MSG.emailMagicLink.defaultMessage,
                  ui_context: GLOBAL_SIGNUP
                }}
              >
                {intl.formatMessage(MSG.emailMagicLink)}
              </Button>
              <Button
                type='submit'
                marginBottom={3}
                colorScheme='primary'
                name='sign-in-with-password-btn'
                tracking={{
                  guid: 'r9kHpffFcNxzezhHgsdyy1',
                  descriptor: MSG.signInWithPassword.defaultMessage,
                  ui_context: GLOBAL_SIGNUP
                }}
              >
                {intl.formatMessage(MSG.signInWithPassword)}
              </Button>
            </Flex>
          </Flex>
        )}
      </Form>
    </div>
  )
}
